import { JetView } from 'webix-jet'; // Importing JetView from the webix-jet library for creating views
import { devConfig } from 'config/config'; // Importing development configuration from the config module

/**
 * Class representing a view for displaying products by betting shop.
 * @extends JetView
 */
export default class tableProductsThirdByBetShopView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        // Retrieve the localization service and its translation function
        const _ = this.app.getService('locale')._;
        // Format date according to the application's date format configuration
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat);
        // Get the current user parameter from the request
        const cur_user = this.getParam('user', true);
        // Preserve the context of 'this' for use in inner functions
        var vthis = this;
        return {
            // Define the main view as a datatable
            view: 'datatable',
            // Unique identifier for the datatable
            id: 'datatable',
            // CSS classes for styling the datatable borders
            css: 'webix_header_border webix_data_border webix_footer_border',
            // Enable row selection
            select: true,
            // Set height based on screen width
            height: screen.width < 500 ? 400 : 0,
            // Define the columns of the datatable
            columns: [
                {
                    // Column for editing with an icon
                    id: 'rating',
                    header: '',
                    width: 50,
                    height: 25,
                    // Tooltip text for the edit icon
                    tooltip: 'Editar',
                    // Template function to render the edit icon
                    template: function (obj) {
                        return "<span class='webix_icon wxi-close edit'></span>";
                    },
                },
                // Column for displaying the ID
                { id: 'Id', header: 'ID', width: 100, sort: 'int' },
                {
                    // Column for displaying products from third parties
                    id: 'ProductsThird',
                    header: 'Producto Terceros',
                    width: 250,
                    sort: 'int',
                },
                {
                    // Column for displaying activation status
                    id: 'IsActivate',
                    header: 'Estado',
                    editor: 'combo', // Enable combo box editor for this column
                    options: [
                        { id: 'A', value: 'Activado' }, // Option for activated status
                        { id: 'I', value: 'Inactivado' }, // Option for deactivated status
                    ],
                    width: 100,
                    sort: 'int',
                },
            ],
            // Define click event handlers
            onClick: {
                // Handler for clicking the edit icon
                edit: function (euv, id) {
                    $$('EditProductsThirdByBetShop').show(); // Show the edit dialog
                },
            },
            // Enable tooltips for the datatable
            tooltip: true,
            // Enable mathematical operations in the datatable
            math: true,
            // Set the data fetching strategy
            loadahead: devConfig.getDefaultDataFetch(),
            // Identifier for the pager component
            pager: 'pagerA',
            // API URL for fetching data, including the current user ID
            url: devConfig.geturlApi() + 'BetShop/GetProductsThird?FromId=' + cur_user + '&',
            // Initial data for the datatable
            data: [
                {
                    Id: '01', // ID of the first product
                    ProductsThird: 'Producto 1', // Name of the first product
                    IsActivate: 'A', // Activation status of the first product
                },
                {
                    Id: '02', // ID of the second product
                    ProductsThird: 'Producto 2', // Name of the second product
                    IsActivate: 'I', // Activation status of the second product
                },
            ],
            // Define event handlers for the datatable
            on: {
                // Handler for double-clicking an item
                onItemDblClick: (id) => {
                    $$('EditProductsThirdByBetShop').show(); // Show the edit dialog
                },
            },
        }; // Placeholder for the configuration content of the view
    }

    /**
     * Initializes the view and its components.
     * @param {Object} grid - The grid component to be initialized.
     */
    init(grid) {
        // Retrieve the URL from the grid data
        var url = grid.data.url;
        // Initialize filter variable
        var filter = '';
        // Get the current user parameter from the URL
        const cur_user = this.getParam('user', true);
        // Initialize arrays for date popup and popup window
        var datePopup = [];
        var popupAdd = '';
        // Perform an AJAX POST request to fetch products for a third party
        webix
            .ajax()
            .headers({
                'Content-type': 'application/json', // Set content type for the request
            })
            .post(
                devConfig.geturlApi() + 'Accounting/GetProductsThirdSelect', // API endpoint
                '', // No request body
                {
                    // Callback for error handling
                    error: function (text, data, XmlHttpRequest) {
                        webix.message('Error! '); // Display error message
                    },
                    // Callback for successful response
                    success: function (text, data, XmlHttpRequest) {
                        var resp = JSON.parse(text); // Parse the JSON response
                        datePopup = resp.Data; // Store the data for the popup
                        // Create a new window UI for adding products
                        popupAdd = webix.ui({
                            view: 'window',
                            id: 'AddProductsThird', // Unique ID for the window
                            head: {
                                view: 'toolbar',
                                cols: [
                                    { view: 'label', label: 'Añadir' }, // Label for the window
                                    {
                                        view: 'icon',
                                        icon: 'wxi-close', // Close icon
                                        click: function () {
                                            this.getTopParentView().hide(); // Hide the window on click
                                        },
                                    },
                                ],
                            },
                            position: 'center', // Center the window on the screen
                            modal: true, // Make the window modal
                            body: {
                                view: 'form',
                                id: 'addform', // Unique ID for the form
                                elements: [
                                    {
                                        view: 'combo',
                                        label: 'Producto Tercero', // Label for the combo box
                                        name: 'ProductsThird', // Name for the form field
                                        options: datePopup, // Options populated from the response
                                    },
                                    {
                                        view: 'combo',
                                        label: 'Estado', // Label for the status combo box
                                        name: 'IsActivate', // Name for the form field
                                        options: [
                                            { id: 'A', value: 'Activado' }, // Active option
                                            { id: 'I', value: 'Inactivado' }, // Inactive option
                                        ],
                                    },
                                    {
                                        cols: [
                                            {
                                                view: 'button',
                                                value: 'Cancelar', // Cancel button
                                                click: function () {
                                                    this.getTopParentView().hide(); // Hide the window on cancel
                                                    $$('addform').setValues(
                                                        $$('addform').getCleanValues(), // Reset form values
                                                    );
                                                },
                                            },
                                            {
                                                view: 'button',
                                                type: 'form', // Button type for form submission
                                                value: 'Guardar', // Save button
                                                click: function ($e) {
                                                    var values = $$('addform').getValues(); // Get form values
                                                    // Perform an AJAX POST request to save the product
                                                    webix
                                                        .ajax()
                                                        .headers({
                                                            'Content-type': 'application/json', // Set content type for the request
                                                        })
                                                        .post(
                                                            devConfig.geturlApi() + 'BetShop/ProductsThird', // API endpoint for saving
                                                            '{"ProductsThird":"' +
                                                                values.ProductsThird +
                                                                '", "BetShop":"' +
                                                                cur_user +
                                                                '", "IsActivate":"' +
                                                                values.IsActivate +
                                                                '"}', // JSON body with product details
                                                            {
                                                                // Callback for error handling
                                                                error: function (text, data, XmlHttpRequest) {
                                                                    webix.message(
                                                                        'Error! ', // Display error message
                                                                    );
                                                                },
                                                                // Callback for successful response
                                                                success: function (text, data, XmlHttpRequest) {
                                                                    webix.message(
                                                                        'Agregado', // Display success message
                                                                    );
                                                                    grid.clearAll(); // Clear the grid data
                                                                    grid.load(
                                                                        url +
                                                                            '?start=0&count=' +
                                                                            grid.data.$pagesize +
                                                                            filter, // Reload grid data with updated parameters
                                                                    );
                                                                },
                                                            },
                                                        );
                                                    $$('addform').setValues(
                                                        $$('addform').getCleanValues(), // Reset form values after submission
                                                    );
                                                    this.getTopParentView().hide(); // Hide the window after saving
                                                },
                                            },
                                        ],
                                    },
                                ],
                            },
                        });
                    },
                },
            );
        // Create a popup window for editing products
        var popup = webix.ui({
            view: 'window', // Define the view type as a window
            id: 'EditProductsThirdByBetShop', // Unique identifier for the window
            head: {
                view: 'toolbar', // Toolbar at the top of the window
                cols: [
                    { view: 'label', label: 'Editar' }, // Label for the toolbar
                    {
                        view: 'icon', // Icon button to close the window
                        icon: 'wxi-close', // Icon type
                        click: function () {
                            // Click event handler
                            this.getTopParentView().hide(); // Hide the window on click
                        },
                    },
                ],
            },
            position: 'center', // Center the window on the screen
            modal: true, // Make the window modal
            body: {
                view: 'form', // Define the body as a form
                id: 'editForm', // Unique identifier for the form
                elements: [
                    { view: 'text', label: 'ID', name: 'Id', readonly: true }, // Read-only text field for ID
                    {
                        view: 'combo', // Combo box for selecting a third-party product
                        label: 'Producto Tercero',
                        name: 'ProductsThird',
                        readonly: true, // Read-only combo box
                    },
                    {
                        view: 'combo', // Combo box for selecting the activation state
                        label: 'Estado',
                        name: 'IsActivate',
                        options: [
                            // Options for the activation state
                            { id: 'A', value: 'Activado' }, // Activated option
                            { id: 'I', value: 'Inactivado' }, // Inactivated option
                        ],
                    },
                    {
                        cols: [
                            // Define a row of buttons
                            {
                                view: 'button', // Cancel button
                                value: 'Cancelar',
                                click: function () {
                                    // Click event handler
                                    this.getTopParentView().hide(); // Hide the window
                                   $$('editForm').setValues(
                                        // Reset form values
                                       $$('editForm').getCleanValues(),
                                    );
                                },
                            },
                            {
                                view: 'button', // Save button
                                type: 'form', // Button type for form submission
                                value: 'Guardar',
                                click: function ($e) {
                                    // Click event handler
                                    var values =$$('editForm').getValues(); // Get form values
                                    webix // Perform an AJAX request
                                        .ajax()
                                        .headers({
                                            'Content-type': 'application/json', // Set content type
                                        })
                                        .post(
                                            devConfig.geturlApi() + // API endpoint
                                                'BetShop/ProductsThird',
                                            '{"Id":"' + // JSON payload
                                                values.Id +
                                                '", "ProductsThird":"' +
                                                values.ProductsThird +
                                                '", "BetShop":"' +
                                                cur_user +
                                                '", "IsActivate":"' +
                                                values.IsActivate +
                                                '"}',
                                            {
                                                error: function (
                                                    // Error callback
                                                    text,
                                                    data,
                                                    XmlHttpRequest,
                                                ) {
                                                    webix.message('Error! '); // Show error message
                                                },
                                                success: function (
                                                    // Success callback
                                                    text,
                                                    data,
                                                    XmlHttpRequest,
                                                ) {
                                                    webix.message(
                                                        // Show success message
                                                        'Actualizado',
                                                    );
                                                    grid.clearAll(); // Clear the grid data
                                                    grid.load(
                                                        // Reload the grid with updated data
                                                        url + '?start=0&count=' + grid.data.$pagesize + filter,
                                                    );
                                                },
                                            },
                                        );
                                   $$('editForm').setValues(
                                        // Reset form values after submission
                                       $$('editForm').getCleanValues(),
                                    );
                                    this.getTopParentView().hide(); // Hide the window
                                },
                            },
                        ],
                    },
                ],
            },
        });
       $$('editForm').bind($$('datatable')); // Bind the edit form to the data table for synchronization
        this.on(this.app, 'productsThird:filter', (filterData) => {
            // Listen for the 'filter' event on the app
            var object = Object.entries(filterData); // Convert filterData object to an array of key-value pairs
            var string1 = ''; // Initialize an empty string to build the query parameters
            for (var i = 0; i < object.length; i++) {
                // Iterate over each key-value pair
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    // Check if the value is not an object and not empty
                    if (object[i][0] == 'CreatedLocalDate') {
                        // Check for 'CreatedLocalDate' key
                        var date = object[i][1].split(' - '); // Split the date range into start and end dates
                        string1 = string1 + '&dateFrom=' + date[0]; // Append start date to the query string
                        string1 = string1 + '&dateTo=' + date[1]; // Append end date to the query string
                    } else {
                        if (object[i][0] == 'ModifiedLocalDate') {
                            // Check for 'ModifiedLocalDate' key
                            var date = object[i][1].split(' - '); // Split the date range into start and end dates
                            string1 = string1 + '&dateFrom2=' + date[0]; // Append start date to the query string
                            string1 = string1 + '&dateTo2=' + date[1]; // Append end date to the query string
                        } else {
                            string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Append other key-value pairs to the query string
                        }
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        // Check if the value is an object
                        var object2 = Object.entries(object[i][1]); // Convert the nested object to an array of key-value pairs
                        for (var j = 0; j < object2.length; j++) {
                            // Iterate over each key-value pair in the nested object
                            if (object2[j][1] !== null) {
                                // Check if the value is not null
                                if (object2[j][0] === 'start') {
                                    // Check for 'start' key
                                    var d = new Date(object2[j][1]); // Create a Date object from the value
                                    var dateFrom = // Format the start date into a query string
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2);
                                    string1 = string1 + '&' + dateFrom; // Append formatted start date to the query string
                                } else {
                                    if (object2[j][0] === 'end') {
                                        // Check for 'end' key
                                        var d = new Date(object2[j][1]); // Create a Date object from the value
                                        var dateTo = // Format the end date into a query string
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2);
                                        string1 = string1 + '&' + dateTo; // Append formatted end date to the query string
                                    }
                                }
                            }
                        }
                    }
                }
            }
            grid.clearAll(); // Clear the existing grid data
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1); // Load new data into the grid with the constructed query string
            filter = string1; // Store the constructed query string in the filter variable
        });
        // Attach an event listener for the 'onAfterSort' event of the grid
        grid.attachEvent('onAfterSort', function (by, dir, as) {
            // Load the grid data with sorting parameters and pagination
            grid.load(
                url + // Base URL for loading data
                    '?start=0&count=' + // Pagination parameters
                    grid.data.$pagesize + // Current page size from grid data
                    filter + // Additional filter parameters
                    '&sort[' + // Sorting parameters
                    by + // Column to sort by
                    ']=' +
                    dir, // Direction of sorting (ascending/descending)
            );
        });

        // Listen for the 'addProductsThird:button' event on the app
        this.on(this.app, 'addProductsThird:button', (filter) => {
            // Show the popup for adding products
            popupAdd.show();
        }); // Placeholder for the initialization content of the view
    }
}

// FILE DOCUMENTED
